import { Base } from '@studiometa/js-toolkit';

/**
 * Variant Selects
 */
export default class VariantSelects extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'VariantSelects',
    emits: ['update-availability'],
  };

  /**
   * mounted
   */
  mounted() {
    this.updateOptions();
    this.productForm = document.querySelector('.main-add-to-cart form');
    [this.currentColor] = this.options;

    if (this.options.includes('')) {
      const addToCart = document.querySelector('#main-add-to-cart');
      if (addToCart) {
        const addButton = addToCart.querySelector('[name="add"]');
        if (addButton) {
          addButton.addEventListener('click', (e) => {
            e.preventDefault();
            const errorsDiv = addToCart.querySelector('[data-ajax-cart-errors]');
            if (errorsDiv) errorsDiv.textContent = window.variantStrings.selectVariant;
          });
        }
      }

      const stickyAddToCart = document.querySelector('#sticky-add-to-cart');
      if (stickyAddToCart) {
        const stickyButton = stickyAddToCart.querySelector('[name="add"]');
        if (stickyButton) {
          stickyButton.addEventListener('click', (e) => {
            e.preventDefault();
            const mainAddToCart = document.querySelector('#main-add-to-cart');
            if (mainAddToCart) {
              const errorsDiv = mainAddToCart.querySelector('[data-ajax-cart-errors]');
              if (errorsDiv) errorsDiv.textContent = window.variantStrings.selectVariant;
            }
            const target = this.$el.querySelector('fieldset') || this.$el;
            const header = document.querySelector('.sticky.top-0');
            const headerOffset = header ? header.offsetHeight : 0;
            const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - 20;
            window.scrollTo({ top, behavior: 'smooth' });
          });
        }
      }
    }
  }

  /**
   * When changing variation
   * @returns {void}
   */
  onChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '');
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }

    this.$root.$update();
  }

  /**
   * Update Options
   * @returns {void}
   */
  updateOptions() {
    this.options = Array.from(this.$el.querySelectorAll('select'), (select) => select.value);
  }

  /**
   * Update Master ID
   * @returns {void}
   */
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  /**
   * Update Gallery based on current variation
   * @returns {void}
   */
  async updateMedia() {
    if (!this.currentVariant) return;
    if (this.currentColor === this.options[0]) return;

    const productGallery = document.querySelector('.product-gallery-grid');

    productGallery.style.height = `${productGallery.offsetHeight}px`;
    [this.currentColor] = this.options;
    this.currentColor = this.currentColor.toLowerCase();
    const variantImages = document.querySelectorAll(`[data-group="${this.currentColor}"]`);
    if (variantImages.length === 0 && productGallery === undefined) {
      return;
    }

    productGallery.classList.add('opacity-0');

    setTimeout(() => {
      productGallery.innerHTML = '';
      variantImages.forEach((image) => {
        productGallery.innerHTML += image.innerHTML;
      });
      productGallery.classList.remove('opacity-0');
    }, 500);
  }

  /**
   * Update URL with variant selection
   * @returns {void}
   */
  updateURL() {
    if (!this.currentVariant || this.$el.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.$el.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  /**
   * Update variant input
   * @returns {void}
   */
  updateVariantInput() {
    const input = this.productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /**
   * Update variant statuses
   * @returns {void}
   */
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.$el.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.$el.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) => variant.available && variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  /**
   * Set Input Availability
   * @param {Array} listOfOptions
   * @param {Array} listOfAvailableOptions
   */
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.textContent = input.getAttribute('value');
      } else {
        input.textContent = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value'),
        );
      }
    });
  }

  /**
   * Render Product Info
   * @returns {void}
   */
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(
      `${this.$el.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.$el.dataset.originalSection
          ? this.$el.dataset.originalSection
          : this.$el.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.querySelector(`#price-${this.$el.dataset.section}`);
        const source = html.querySelector(
          `#price-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const upsellSource = html.querySelector('#upsell-products');
        const upsellDestination = document.querySelector('#upsell-products');

        const variantsSource = html.querySelector(
          `#variant-radios-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const variantsDestination = document.querySelector(
          `#variant-radios-${this.$el.dataset.section}`,
        );

        const addToCartSource = html.querySelector('#main-add-to-cart');
        const addToCartDestination = document.querySelector('#main-add-to-cart');

        const stickyAddToCartSource = html.querySelector('#sticky-add-to-cart');
        const stickyAddToCartDestination = document.querySelector('#sticky-add-to-cart');

        if (upsellSource && upsellDestination) {
          upsellDestination.innerHTML = upsellSource.innerHTML;
        }

        if (source && destination) destination.innerHTML = source.innerHTML;

        if (variantsSource && variantsDestination) {
          variantsDestination.innerHTML = variantsSource.innerHTML;
          variantsDestination.classList.toggle(
            'hidden',
            variantsSource.classList.contains('hidden'),
          );
        }

        if (addToCartSource && addToCartDestination) {
          addToCartDestination.innerHTML = addToCartSource.innerHTML;
          addToCartDestination.classList.toggle(
            'hidden',
            addToCartSource.classList.contains('hidden'),
          );
        }

        if (stickyAddToCartSource && stickyAddToCartDestination) {
          stickyAddToCartDestination.innerHTML = stickyAddToCartSource.innerHTML;
          stickyAddToCartDestination.classList.toggle(
            'hidden',
            stickyAddToCartSource.classList.contains('hidden'),
          );
        }
        this.$root.$update();
      });
  }

  /**
   * Toggle add Button
   * @param  {boolean} disable
   * @param  {string}  text
   * @returns {void}
   */
  toggleAddButton(disable = true, text = '') {
    const productForm = document.querySelector(`#product-form-${this.$el.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.dataset.ref = 'disabledBtn[]';
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('data-ref', 'disabledBtn[]');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  /**
   * Set Unvailable to btn
   */
  setUnavailable() {
    const button = document.querySelector(`#product-form-${this.$el.dataset.section}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.querySelector(`#price-${this.$el.dataset.section}`);
    const inventory = document.querySelector(`#Inventory-${this.$el.dataset.section}`);
    const sku = document.querySelector(`#Sku-${this.$el.dataset.section}`);
    const pricePerItem = document.querySelector(`#Price-Per-Item-${this.$el.dataset.section}`);
    const volumeNote = document.querySelector(`#Volume-Note-${this.$el.dataset.section}`);
    const volumeTable = document.querySelector(`#Volume-${this.$el.dataset.section}`);
    const qtyRules = document.querySelector(`#Quantity-Rules-${this.$el.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  /**
   * Get variant Data
   * @returns {Array}
   */
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.$el.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
